import {
  Profile2User,
  Chart,
  NoteFavorite,
  Box,
  Category,
  UserSquare,
  Setting3,
} from 'iconsax-react';
import { ROUTE_PATH } from './route-util';
import * as IconSax from 'iconsax-react';

type Navigation = {
  children: ChildNav[];
  icon: typeof IconSax.Icon;
} & ChildNav;

type ChildNav = {
  title: string;
  toUrl: string;
};

const navigationUtil: Navigation[] = [
  {
    title: 'Dashboard',
    toUrl: ROUTE_PATH.dashboard,
    icon: Chart,
    children: [],
  },
  {
    title: 'Orders',
    toUrl: '#',
    icon: NoteFavorite,
    children: [
      {
        title: 'Bookings',
        toUrl: ROUTE_PATH.orders.order,
      },
      {
        title: 'Quotations',
        toUrl: ROUTE_PATH.orders.quotations,
      },
      {
        title: 'Payments',
        toUrl: ROUTE_PATH.orders.payments,
      },
      {
        title: 'Expenses',
        toUrl: ROUTE_PATH.orders.invoices,
      },
    ],
  },
  // {
  //   title: 'Expenses',
  //   toUrl: '#',
  //   icon: WalletMoney,
  //   children: [
  //     {
  //       title: 'Invoices',
  //       toUrl: ROUTE_PATH.expense.invoices,
  //     },
  //   ],
  // },
  {
    title: 'Participants',
    toUrl: '#',
    icon: Profile2User,
    children: [
      {
        title: 'Customers',
        toUrl: ROUTE_PATH.participants.customer,
      },
      {
        title: 'Potentials',
        toUrl: ROUTE_PATH.participants.potential,
      },
      {
        title: 'Suppliers',
        toUrl: ROUTE_PATH.participants.supplier,
      },
    ],
  },
  {
    title: 'Reminders',
    toUrl: ROUTE_PATH.notification.root,
    icon: IconSax.Notification,
    children: [],
  },
  {
    title: 'Menus',
    toUrl: '#',
    icon: Category,
    children: [
      {
        title: 'Menu Package',
        toUrl: ROUTE_PATH.menus.package,
      },
      {
        title: 'Food Menu',
        toUrl: ROUTE_PATH.menus.food,
      },
    ],
  },
  // {
  //   title: 'Groceries',
  //   toUrl: ROUTE_PATH.prepareGrocery.root,
  //   icon: MenuBoard,
  //   children: [],
  // },
  {
    title: 'Inventories',
    toUrl: '#',
    icon: Box,
    children: [
      {
        title: 'Product',
        toUrl: ROUTE_PATH.inventories.product,
      },
      {
        title: 'Category',
        toUrl: ROUTE_PATH.inventories.categories,
      },
      {
        title: 'Unit',
        toUrl: ROUTE_PATH.inventories.units,
      },
      {
        title: 'Report',
        toUrl: ROUTE_PATH.inventories.inventoryReport,
      },
    ],
  },
  {
    title: 'Users',
    toUrl: '#',
    icon: UserSquare,
    children: [
      {
        title: 'Users',
        toUrl: ROUTE_PATH.users.root,
      },
      {
        title: 'Roles',
        toUrl: ROUTE_PATH.users.roles,
      },
      {
        title: 'Permissions',
        toUrl: ROUTE_PATH.users.permission,
      },
    ],
  },
  {
    title: 'Settings',
    toUrl: ROUTE_PATH.setting.root,
    icon: Setting3,
    children: [],
  },
];

export default navigationUtil;
